export default __webpack_public_path__ + "0b2757f.png";